import { LocalizedForm } from "common/localization";

export default class NakiNigunAlbumTrackEditTitleForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "title",
                    label: "ADMINISTRATION.NAKI_NIGUN.ARTIST.PREVIEW.ALBUM.SONG_LIST.FIELDS.TITLE_LABEL",
                    placeholder: "ADMINISTRATION.NAKI_NIGUN.ARTIST.PREVIEW.ALBUM.SONG_LIST.FIELDS.TITLE_PLACEHOLDER",
                    rules: "required|string",
                },
            ],
        };
    }
}
